import { render, staticRenderFns } from "./ReportHandler.vue?vue&type=template&id=6f282d9e&scoped=true"
import script from "./ReportHandler.vue?vue&type=script&lang=js"
export * from "./ReportHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f282d9e",
  null
  
)

export default component.exports